import { basicInfo } from '../../api/profile'

export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        saveBasicInfo({ commit, rootGetters }, updateUser) {
            let profileId = rootGetters['profile/memberId']
            let entityId = rootGetters['profile/entityId']
            let requestUrl = basicInfo(entityId, profileId)
            const promise = axios.put(requestUrl, updateUser)

            promise.then(response => {
                commit('saveBasicInfo', response.data.user)
            }).catch(error => {})

            return promise
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/profile/about.js